import { Product } from '@mc/api'
import { getNumberOfInstructors } from '@mc/instructors'
import { paths } from '@mc/paths'

export const components = {
  br: (
    <>
      <br />
      <br />
    </>
  ),
  bold: <span className='mc-text--bold' />,
  ul: (
    <ul
      style={{
        listStyle: 'disc outside',
        margin: 'var(--mc-scale-4) 0 var(--mc-scale-4) var(--mc-scale-8)',
      }}
    />
  ),
  li: <li style={{ marginBottom: 'var(--mc-scale-2)' }} />,
  'help-center': (
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    <a
      className='mc-text--link'
      target='_blank'
      rel='noopener noreferrer'
      href={paths.helpCenter}
    />
  ),
  'refund-request': (
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    <a
      className='mc-text--link'
      target='_blank'
      rel='noopener noreferrer'
      href={paths.howToRefund}
    />
  ),
  'contact-us': (
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    <a
      className='mc-text--link'
      target='_blank'
      rel='noopener noreferrer'
      href={paths.helpCenter}
    />
  ),
}

export const getValues = ({ annualPass }: { annualPass: Product }) => ({
  instructors: getNumberOfInstructors(),
  monetizedPrice: annualPass?.price,
})
